import { readingTime, supportedLanguages } from "reading-time-estimator";

declare type ReadingTime = {
    readonly minutes: number;
    readonly words: number;
    readonly text: string;
};

// en
const LANGUAGE = supportedLanguages[0];
const WORDS_PER_MINUTE = 265;

export const calculateReadingTime = (text: string): ReadingTime =>
    text
        ? readingTime(text, WORDS_PER_MINUTE, LANGUAGE)
        : {
              minutes: 1,
              words: 0,
              text: "",
          };
